import { defineQuery, defineSystem } from "bitecs";
import { Position, Velocity, PhysicsBody } from "../components";
import type { GameWorld } from "../world";

const movementQuery = defineQuery([Position, Velocity, PhysicsBody]);

export const movementSystem = defineSystem((world: GameWorld) => {
  const dt = world.time.delta;
  const entities = movementQuery(world);

  for (let i = 0; i < entities.length; i++) {
    const eid = entities[i];

    // Apply gravity when airborne
    if (!PhysicsBody.onGround[eid]) {
      Velocity.y[eid] -= PhysicsBody.gravity[eid] * dt;
    }

    // Update position
    Position.x[eid] += Velocity.x[eid] * dt;
    Position.y[eid] += Velocity.y[eid] * dt;
    Position.z[eid] += Velocity.z[eid] * dt;

    // Horizontal friction (damping)
    Velocity.x[eid] *= 0.9;
    Velocity.z[eid] *= 0.9;

    // Clamp near-zero velocities
    if (Math.abs(Velocity.x[eid]) < 0.001) Velocity.x[eid] = 0;
    if (Math.abs(Velocity.z[eid]) < 0.001) Velocity.z[eid] = 0;
  }

  return world;
});
